import './news.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { SectionHeader } from '../components/SectionHeader'
import { HudCard } from '../components/HudCard'
import { MonoTag } from '../components/MonoTag'

const EC_URL =
  'https://environment.ec.europa.eu/topics/forests/deforestation/regulation-deforestation-free-products_en'

export default function News() {
  const { lang } = useI18n()
  const C = (
    {
      vi: {
        kicker: 'EUDR ĐANG NÓNG',
        title: (
          <>
            Những điều cần <em>theo dõi</em>.
          </>
        ),
        sub: 'Ba điểm mấu chốt định hình lộ trình tuân thủ EUDR cho cà phê Việt Nam. Bám sát nguồn chính thức, không đoán.',
        source: 'Nguồn: European Commission',
        readMore: 'Đọc trên EC',
        topics: [
          {
            tag: 'TIMELINE',
            h: 'Mốc áp dụng 30/12/2026',
            p: 'Doanh nghiệp lớn phải tuân thủ EUDR từ ngày 30/12/2026. Mốc cắt phá rừng là 31/12/2020 — lô hàng không được liên quan đến đất rừng bị chuyển đổi sau ngày này.',
          },
          {
            tag: 'COUNTRY RISK',
            h: 'Việt Nam = rủi ro THẤP',
            p: 'Theo Reg. 2025/1093, Việt Nam được xếp nhóm rủi ro thấp. Nghĩa vụ thẩm định (due diligence) vẫn áp dụng — bằng chứng định vị và truy xuất nguồn gốc vẫn là bắt buộc.',
          },
          {
            tag: 'TRACES NT · DDS',
            h: 'TRACES NT & DDS',
            p: 'Nhà nhập khẩu EU nộp Bản tuyên bố trách nhiệm giải trình (DDS) qua hệ thống TRACES NT, kèm dữ liệu định vị thửa đất. ARGO xuất Lot Passport + GeoJSON khớp định dạng này.',
          },
        ],
      },
      en: {
        kicker: 'EUDR IN FOCUS',
        title: (
          <>
            What to <em>watch</em>.
          </>
        ),
        sub: 'Three pivotal points shaping the EUDR compliance path for Vietnamese coffee. Anchored to the official source, no guesswork.',
        source: 'Source: European Commission',
        readMore: 'Read on EC',
        topics: [
          {
            tag: 'TIMELINE',
            h: 'Applies from 30/12/2026',
            p: 'Large operators must comply with the EUDR from 30 Dec 2026. The deforestation cutoff is 31 Dec 2020 — shipments must not be linked to forest land converted after that date.',
          },
          {
            tag: 'COUNTRY RISK',
            h: 'Vietnam = LOW risk',
            p: 'Under Reg. 2025/1093, Vietnam is classified as low risk. Due diligence obligations still apply — geolocation evidence and traceability remain mandatory.',
          },
          {
            tag: 'TRACES NT · DDS',
            h: 'TRACES NT & DDS',
            p: 'EU importers file a Due Diligence Statement (DDS) through the TRACES NT system, with plot geolocation data. ARGO exports a Lot Passport + GeoJSON matching this format.',
          },
        ],
      },
    } as const
  )[lang]

  return (
    <section id="news" className="section news">
      <div className="container">
        <SectionHeader index="06" kicker={C.kicker} title={C.title} sub={C.sub} />

        <div className="news-grid">
          {C.topics.map((topic, i) => (
            <Reveal key={topic.h} delay={0.06 * i} y={24}>
              <HudCard
                className="news-card"
                header={<span className="news-card-tag">{topic.tag}</span>}
                brackets
              >
                <h3 className="news-card-h">{topic.h}</h3>
                <p className="news-card-p">{topic.p}</p>
                <div className="news-card-foot">
                  <span className="news-card-src mono">{C.source}</span>
                  <a
                    className="news-card-link"
                    href={EC_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {C.readMore}
                    <span className="news-card-arrow" aria-hidden>
                      ↗
                    </span>
                  </a>
                </div>
              </HudCard>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.24}>
          <div className="news-foot">
            <MonoTag live>LIVE</MonoTag>
            <span className="news-foot-note mono">
              EUDR · Reg. 2023/1115 · Reg. 2025/1093
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
